import * as React from 'react';
import s from './AppHeader.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import { Button, Heading, Text } from 'wix-style-react';
import classNames from 'classnames';
import { Template, Theme } from 'enums';
import { Trans, useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';

export interface AnonymousHeaderProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const AnonymousHeaderComp: React.FC<AnonymousHeaderProps> = (props) => {
  const {
    rootStore: { appStore },
  } = props;

  // we don't want anonymus users to get popup in any case
  appStore.removeUnloadListener();
  const { t } = useTranslation();
  const { theme, template } = usePageModeContext();
  const titleKey = t(
    theme === Theme.EditorX
      ? 'app.editorx.header.anonymous.title'
      : 'app.header.anonymous.title',
  );
  const subtitleKey =
    theme === Theme.EditorX
      ? 'app.editorx.header.anonymous.subtitle'
      : 'app.header.anonymous.subtitle';
  const getStartedKey = t(
    template === Template.Grid
      ? 'app.header.anonymous.advanced.get_started'
      : 'app.header.anonymous.get_started',
  );

  return (
    <>
      <div
        className={classNames(s.anonymousCta, theme)}
        data-hook='anonymous-header'
      >
        <Heading
          appearance='H1'
          className={classNames(s.anonymousTitle, theme)}
          dataHook='page-title'
        >
          {titleKey}
        </Heading>
        <Text
          tagName='p'
          weight='normal'
          dataHook='page-subtitle'
          className={classNames(s.anonymousSubtitle, theme)}
        >
          <Trans i18nKey={subtitleKey}>
            app.editorx.header <br /> .anonymous.subtitle
          </Trans>
        </Text>
        <div className={classNames(s.ctaButton, s.newTabs, theme)}>
          <Button size='large' dataHook='get-started' skin='premium'>
            <a
              href={appStore.getSignInRedirectionLink()}
              className={s.anonymusLink}
            >
              {getStartedKey}
            </a>
          </Button>
        </div>
      </div>
    </>
  );
};

export const AnonymousHeader = withInjectedRootStore(
  withExperiments(AnonymousHeaderComp),
);
